// Auth strings for GetPaid: the login screen (magic-link + Google + passkey)
// and the magic-link consume landing. EN is the source of truth — every key
// here MUST have a native-Portuguese counterpart in auth.pt-BR.ts.
const auth: Record<string, string> = {
  // -------- Login --------
  'auth.login.title': 'Sign in to GetPaid',
  'auth.login.subtitle': 'Enter your email and we’ll send you a magic sign-in link.',
  'auth.login.expiredBanner': 'Your session expired. Please sign in again.',
  'auth.login.referralBanner': "You've been invited — get 50% off our fee for your first month.",

  'auth.login.email': 'Email',
  'auth.login.emailPlaceholder': 'you@company.com',
  'auth.login.submit': 'Email me a sign-in link',
  'auth.login.submitting': 'Sending link…',

  'auth.login.sent.title': 'Check your email',
  'auth.login.sent.body': 'We sent a sign-in link to {email}. The link expires in 15 minutes.',
  'auth.login.sent.tryAgain': 'Use a different email',

  'auth.login.or': 'or',
  'auth.login.google': 'Continue with Google',
  'auth.login.googleLoading': 'Connecting to Google…',
  'auth.login.passkey': 'Sign in with a passkey',
  'auth.login.passkeyLoading': 'Waiting for your passkey…',

  'auth.login.error.generic': 'Sign-in failed. Please try again.',
  'auth.login.error.google': 'Google sign-in didn’t work. Please try again.',
  'auth.login.error.googleCancelled': 'Google sign-in was cancelled.',
  'auth.login.error.passkey': 'Passkey sign-in didn’t work. Please try again.',
  'auth.login.error.passkeyCancelled': 'Passkey sign-in was cancelled.',

  // -------- Magic-link consume --------
  'auth.consume.loading': 'Signing you in…',
  'auth.consume.error.expired': 'This sign-in link has expired. Please request a new one.',
  'auth.consume.error.used': 'This sign-in link has already been used.',
  'auth.consume.error.invalid': 'This sign-in link is invalid.',
  'auth.consume.error.generic': 'Sign-in failed. Please request a new link.',
  'auth.consume.requestNew': 'Request a new link',
};

export default auth;
